<template>
  <section class="affiliate-activity">
    <div class="affiliate-activity__toolbar">
      <div><h3>{{ title }}</h3><p>{{ filteredRows.length }} {{ $t('records') }}</p></div>
      <label class="affiliate-activity__search"><span>{{ $t('Search') }}</span><input v-model="search" type="search" :placeholder="$t('Search customer, IP, type or status')" /></label>
    </div>
    <div class="affiliate-activity__scroll">
      <table>
        <thead><tr><th v-for="column in columns" :key="column.key" scope="col" :aria-sort="sortKey === column.key ? (sortDirection === 1 ? 'ascending' : 'descending') : 'none'"><button class="affiliate-activity__sort" type="button" @click="sortBy(column.key)">{{ $t(column.label) }}<span v-if="sortKey === column.key" aria-hidden="true">{{ sortDirection === 1 ? ' ↑' : ' ↓' }}</span></button></th></tr></thead>
        <tbody>
          <tr v-for="(row, index) in visibleRows" :key="row.id || page + '-' + index">
            <td class="affiliate-activity__customer"><strong>{{ row.buyer_fullname || $t('Not provided') }}</strong><span>{{ row.buyer_email || '—' }}</span></td>
            <td class="affiliate-activity__ip">{{ row.buyer_ip || '—' }}</td>
            <td><span class="affiliate-activity__type">{{ row.transaction_type || '—' }}</span></td>
            <td><span class="affiliate-activity__status">{{ row.commission_status || '—' }}</span></td>
            <td class="affiliate-activity__date">{{ row.formatted_date_time || '—' }}</td>
          </tr>
          <tr v-if="!filteredRows.length"><td colspan="5" class="affiliate-activity__empty">{{ $t('No matching records') }}</td></tr>
        </tbody>
      </table>
    </div>
    <div class="affiliate-activity__footer">
      <span aria-live="polite">{{ firstRow }}–{{ lastRow }} {{ $t('of') }} {{ filteredRows.length }}</span>
      <div class="affiliate-activity__pagination"><button type="button" :disabled="page === 1" @click="page--">{{ $t('Previous') }}</button><span>{{ $t('Page') }} {{ page }} {{ $t('of') }} {{ pageCount }}</span><button type="button" :disabled="page >= pageCount" @click="page++">{{ $t('Next') }}</button></div>
    </div>
  </section>
</template>
<script>
export default {
  props: { rows: { type: Array, default: () => [] }, title: { type: String, default: '' } },
  data() { return { search: '', page: 1, pageSize: 5, sortKey: '', sortDirection: 1, columns: [{key:'buyer_fullname',label:'Customer'},{key:'buyer_ip',label:'IP Address'},{key:'transaction_type',label:'Type'},{key:'commission_status',label:'Commission'},{key:'formatted_date_time',label:'Date Time'}] }; },
  computed: {
    filteredRows() {
      const query = this.search.trim().toLocaleLowerCase();
      if (!query) return this.rows;
      return this.rows.filter(row => ['buyer_fullname', 'buyer_email', 'buyer_ip', 'transaction_type', 'commission_status', 'formatted_date_time'].some(key => String(row[key] || '').toLocaleLowerCase().includes(query)));
    },
    sortedRows() {
      if (!this.sortKey) return this.filteredRows;
      return this.filteredRows.slice().sort((a, b) => String(a[this.sortKey] || '').localeCompare(String(b[this.sortKey] || ''), undefined, { numeric: true, sensitivity: 'base' }) * this.sortDirection);
    },
    pageCount() { return Math.max(1, Math.ceil(this.filteredRows.length / this.pageSize)); },
    visibleRows() { return this.sortedRows.slice((this.page - 1) * this.pageSize, this.page * this.pageSize); },
    firstRow() { return this.filteredRows.length ? (this.page - 1) * this.pageSize + 1 : 0; },
    lastRow() { return Math.min(this.page * this.pageSize, this.filteredRows.length); }
  },
  methods: {
    sortBy(key) { this.sortDirection = this.sortKey === key ? -this.sortDirection : 1; this.sortKey = key; this.page = 1; }
  },
  watch: {
    search() { this.page = 1; },
    rows() { this.page = 1; },
    pageCount(value) { this.page = Math.min(this.page, value); }
  }
};
</script>
<style scoped>
.affiliate-activity { margin: 20px; border: 1px solid #e5e9f0; border-radius: 14px; overflow: hidden; background: white; }
.affiliate-activity__toolbar { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 20px; }
h3 { margin: 0; font-size: 16px; font-weight: 600; color: #1e293b; }
p { margin: 5px 0 0; color: #64748b; font-size: 12px; }
.affiliate-activity__search { width: 300px; max-width: 100%; }
.affiliate-activity__search > span { display: block; font-size: 12px; color: #64748b; margin-bottom: 6px; }
input { box-sizing: border-box; width: 100%; border: 1px solid #dce2eb; border-radius: 9px; padding: 10px 12px; font: inherit; font-size: 13px; background: #f8fafc; }
input:focus { outline: 2px solid var(--brand-primary, #ed6198); outline-offset: 2px; }
.affiliate-activity__scroll { overflow-x: auto; }
table { width: 100%; min-width: 820px; border-collapse: collapse; table-layout: fixed; }
th { text-align: left; padding: 13px 16px; background: #f7f9fc; color: #64748b; font-size: 12px; font-weight: 600; border-top: 1px solid #edf0f5; border-bottom: 1px solid #edf0f5; }
th:first-child { width: 25%; } th:nth-child(2) { width: 21%; } th:nth-child(3) { width: 16%; } th:nth-child(4) { width: 16%; } th:last-child { width: 22%; }
td { padding: 18px 16px; color: #334155; font-size: 13px; border-bottom: 1px solid #edf0f5; vertical-align: middle; overflow-wrap: anywhere; }
tbody tr:hover { background: #fff8fb; }
.affiliate-activity__customer strong { display: block; font-weight: 600; color: #1e293b; }
.affiliate-activity__customer > span { display: block; color: #64748b; font-size: 12px; margin-top: 5px; }
.affiliate-activity__ip { color: #64748b; font-size: 12px; font-variant-numeric: tabular-nums; }
.affiliate-activity__date { font-variant-numeric: tabular-nums; line-height: 1.7; overflow-wrap: normal; }
.affiliate-activity__type, .affiliate-activity__status { display: inline-block; font-size: 12px; line-height: 1.5; border-radius: 6px; padding: 4px 8px; background: #f1f5f9; color: #475569; }
.affiliate-activity__status { background: #fff0f6; color: #a63e68; }
.affiliate-activity__empty { text-align: center; padding: 40px; color: #64748b; }
.affiliate-activity__footer { padding: 14px 20px; display: flex; justify-content: space-between; align-items: center; color: #64748b; font-size: 12px; gap: 12px; }
.affiliate-activity__pagination { display: flex; gap: 14px; align-items: center; }
button { padding: 7px 11px; border: 1px solid #e2e8f0; border-radius: 7px; background: white; font: inherit; color: #334155; cursor: pointer; }
.affiliate-activity__sort { border: 0; padding: 0; background: transparent; font-weight: 600; color: inherit; text-align: left; }
button:disabled { opacity: .45; cursor: default; }
button:focus-visible { outline: 2px solid var(--brand-primary, #ed6198); }
@media(max-width: 640px) { .affiliate-activity { margin: 12px; } .affiliate-activity__toolbar, .affiliate-activity__footer { flex-wrap: wrap; } .affiliate-activity__search { width: 100%; } }
</style>
